// extracted by mini-css-extract-plugin
export default {"related_item":"related_item__2ecdf14b"};